import React from "react";
import PageHero from "./PageHero";

export function LegalSection({ title, children, id }) {
  return (
    <section id={id} className="tv-card p-6 md:p-8 scroll-mt-28">
      {title && (
        <h2 className="text-xl font-bold text-white font-display mb-4">{title}</h2>
      )}
      <div className="space-y-4 text-[var(--tv-muted)] text-sm md:text-base leading-relaxed">
        {children}
      </div>
    </section>
  );
}

export default function LegalPageLayout({
  title,
  highlight,
  subtitle,
  image,
  updatedAt = "31 Ağustos 2026",
  children,
}) {
  return (
    <div>
      <PageHero title={title} highlight={highlight} subtitle={subtitle} image={image} />
      <div className="tv-container py-14 max-w-4xl space-y-6">
        {updatedAt && (
          <p className="text-sm text-[var(--tv-muted)]">
            Son güncelleme: <span className="text-white">{updatedAt}</span>
          </p>
        )}
        {children}
      </div>
    </div>
  );
}
